import { ErrorBoundary } from '@shared/components';
import { links } from '@shared/utils';
import { RouteObject } from 'react-router-dom';

import { CrossSellerLayout } from '../layout';
import { Payment, Plans, Success, Summary } from '../pages';

export const CrossSellerRoutesPublic = (): RouteObject[] => {
  return [
    {
      element: <CrossSellerLayout />,
      children: [
        {
          path: links.crossSeller.main,
          element: <Plans />,
        },
        {
          path: links.crossSeller.plans,
          element: <Plans />,
        },
        {
          path: links.crossSeller.payment,
          element: <Payment />,
        },
        {
          path: links.crossSeller.summary,
          element: <Summary />,
        },
        {
          path: links.crossSeller.success,
          element: <Success />,
        },
      ],
      errorElement: <ErrorBoundary />,
    },

    {
      path: '*',
      element: <CrossSellerLayout />,
      children: [
        {
          path: '*',
          index: true,
          element: <Plans />,
        },
      ],
    },
  ];
};

export const CrossSellerRoutesProtected: RouteObject[] = [
  {
    element: <CrossSellerLayout />,
    children: [
      {
        path: links.crossSeller.main,
        element: <Plans />,
      },
      {
        path: links.crossSeller.plans,
        element: <Plans />,
      },
      {
        path: links.crossSeller.payment,
        element: <Payment />,
      },
      {
        path: links.crossSeller.summary,
        element: <Summary />,
      },
    ],
    errorElement: <ErrorBoundary />,
  },

  {
    path: '*',
    element: <CrossSellerLayout />,
    children: [
      {
        path: '*',
        index: true,
        element: <Plans />,
      },
    ],
  },
];
